import React from "react";
import { Field, NumberInput, PanelSection } from "./controls";

const POSITION_KEYS = {
  rect: ["x", "y", "width", "height"],
  image: ["x", "y", "width", "height"],
  text: ["x", "y", "fontSize"],
  circle: ["cx", "cy", "r"],
  ellipse: ["cx", "cy", "rx", "ry"],
  line: ["x1", "y1", "x2", "y2"],
  polygon: [],
  path: [],
};

export default function TransformControls({ type, attrs, setAttr }) {
  const posKeys = POSITION_KEYS[type] || [];

  return (
    <PanelSection title="Transform">
      {posKeys.length > 0 && (
        <div className="grid grid-cols-2 gap-2">
          {posKeys.map((k) => (
            <Field key={k} label={k}>
              <NumberInput value={attrs[k]} onChange={(v) => setAttr(k, v)} testId={`attr-${k}-input`} />
            </Field>
          ))}
        </div>
      )}
      <div className="grid grid-cols-2 gap-2 mt-2">
        <Field label="Rotation (°)">
          <NumberInput value={attrs.rotation} onChange={(v) => setAttr("rotation", v)} testId="attr-rotation-input" />
        </Field>
      </div>
    </PanelSection>
  );
}
